export const SUCCESS_STORIES_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    image: "",
    video_link: "",
    name_text: "John Doe",
    name_text_color: "#000000",
    designation: "Software Engineer",
    designation_text_color: "#666666",
    gradient_angle: "182deg",
    gradient_start_color: "rgba(0, 0, 0, 0.00)",
    gradient_start_position: "-19.25%",
    gradient_end_color: "#0A3D5B",
    gradient_end_position: "64.37%",
    priority: 1,
  },

  SUCCESS_STORIES_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Success Stories Title",
      value: "Success Stories",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Success Stories Title",
      required: false,
      defaultValue: "Success Stories",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Left Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Left Navigation Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "left_navigation_icon_alt",
      label: "Left Navigation Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for left navigation icon",
      required: false,
      defaultValue: "Left navigation",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Right Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Right Navigation Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "right_navigation_icon_alt",
      label: "Right Navigation Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for right navigation icon",
      required: false,
      defaultValue: "Right navigation",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Success Stories Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Success Stories",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Image",
      required: true,
    },
    {
      header: "Image Alt Text",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
      required: false,
    },
    {
      header: "Video",
      fieldName: "video_link",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Video",
      required: false,
    },
    {
      header: "Name Text",
      fieldName: "name_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Name",
      required: true,
    },
    {
      header: "Name Text Color",
      fieldName: "name_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Name Text Color",
      required: false,
    },
    {
      header: "Designation",
      fieldName: "designation",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Designation",
      required: true,
    },
    {
      header: "Designation Text Color",
      fieldName: "designation_text_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Designation Text Color",
      required: false,
    },
    {
      header: "Gradient Angle",
      fieldName: "gradient_angle",
      value: "182deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 182deg, 90deg)",
      required: false,
    },
    {
      header: "Gradient Start Color",
      fieldName: "gradient_start_color",
      value: "rgba(0, 0, 0, 0.00)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(0, 0, 0, 0.00)",
      required: false,
    },
    {
      header: "Gradient Start Position",
      fieldName: "gradient_start_position",
      value: "-19.25%",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter position (e.g., -19.25%, 0%)",
      required: false,
    },
    {
      header: "Gradient End Color",
      fieldName: "gradient_end_color",
      value: "#0A3D5B",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "#0A3D5B or rgba(10, 61, 91, 1)",
      required: false,
    },
    {
      header: "Gradient End Position",
      fieldName: "gradient_end_position",
      value: "64.37%",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter position (e.g., 64.37%, 100%)",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ],
};

